import React, { useState } from "react";
import about from "../../assets/image/about_nha_pg_logo.png";
import { EncryptServices, MobileOTPServices } from "../../services";
import { useDispatch, useSelector } from "react-redux";
import { setMobileNumber, setUuid } from "../../redux/slices/abhaSlice";
import qrcode from "../../assets/image/qrcode.png";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
const LoginMobileOTPSend = ({
  setIsVerified,
  setMobileOTPSent,
  setIsVerifiedOtp,
  setCurrentStep
}) => {
  const [mobile, setMobile] = useState("");
  const [patientdetail, setPatientdetail] = useState("");
  const [msg, setMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [otpGuid, setOtpGuid] = useState("");
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const dispatch = useDispatch();
  const [showQrModal, setShowQrModal] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmedMobile = mobile.trim();

    const isValidMobile = /^[6-9]\d{9}$/.test(trimmedMobile);

    if (isValidMobile) {
      sendOtp();
      setMsg("");
    } else {
      setMsg(
        "Please enter a valid 10-digit mobile number starting with 6, 7, 8, or 9."
      );
    }
  };

  // const mobileLength = mobile.trim().length > 10;
  const mobileLength = mobile.length > 9;

  const sendOtp = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const emobile = await EncryptServices({
        headers: {},
        body: { data: mobile }
      });
      // console.log(emobile, "===+");

      dispatch(setMobileNumber(mobile));
      localStorage.setItem("mobile", mobile);
      localStorage.setItem("patientdetail", patientdetail);
      const body = {
        mobile: emobile
      };

      const response = await MobileOTPServices({ body });
      console.log("OTP Send Response:", response);

      if (response?.success) {
        if (response.data?.otpGuid) {
          const otpData = response.data
          console.log(otpData, "data");

          dispatch(setUuid(otpData.otpGuid));
          if (otpData?.otpGuid) {
            setOtpGuid(otpData.otpGuid);
            localStorage.setItem("otpResponse", JSON.stringify(response));
            setOtp(["", "", "", "", "", ""]);
            toast.success("OTP sent successfully!");
            // setIsVerified(true);
            setCurrentStep("LoginMobileOtpVerify");
            // setMobileOTPSent(false)
          } else {
            toast.error("OTP sent but technical error occurred");
            localStorage.removeItem("otpResponse");
          }
        } else {
          const errorMessage =
            response.message || "Failed to send OTP";
          toast.error(errorMessage);

          if (!response.status) {
            setOtpGuid("");
            localStorage.removeItem("otpResponse");
          }
        }
      } else {
        toast.error(response?.message || "Failed to send OTP");
        // Swal.fire({
        //   title: response.data.length===0?"No Profile Found":"",
        //   text: "Do you want to continue to create profile and Link ABHA?",
        //   icon: "warning",
        //   showCancelButton: true,
        //   confirmButtonColor: "#3085d6",
        //   cancelButtonColor: "#d33",
        //   confirmButtonText: "Yes!"
        // }).then((result) => {
        //   if (result.isConfirmed) {
        //     setCurrentStep("SendAdharOTP");
        //   }
        // });
        return response;
      }
    } catch (error) {
      console.log(error, "error");
      toast.error("Failed to send OTP. Please try again.");
      localStorage.removeItem("otpResponse");
    } finally {
      setIsLoading(false);
    }
  };
  const handleScanQrCode = () => {
    setShowQrModal(true);
  };

  return (
    <>
      <section className="container">
        <div className="abha-create-steps">
          <div className="row">
            <div className="col-md-6">
              <div className="create-abha">
                <h2>Create ABHA Number in 3 Steps</h2>
                <p>
                  Create ABHA and store all your medical records in one place.
                  Take part in the{" "}
                  <span className="highlight">
                    Ayushman Bharat Digital Mission (ABDM)
                  </span>{" "}
                  and get started on your digital health journey.
                </p>

                <div className="vertical-steps">
                  <div className="step-item">
                    <div className="step-marker">1</div>
                    <div className="step-content">
                      <h4>Verify Aadhaar Details</h4>
                      <p>
                        Enter your Aadhaar number and verify with OTP received
                        on Aadhaar linked mobile number.
                      </p>
                    </div>
                  </div>

                  <div className="step-line" />

                  <div className="step-item">
                    <div className="step-marker">2</div>
                    <div className="step-content">
                      <h4>Link Mobile Number</h4>
                      <p>
                        Enter your mobile number and verify with OTP to link
                        with ABHA .
                      </p>
                    </div>
                  </div>

                  <div className="step-line" />

                  <div className="step-item">
                    <div className="step-marker">3</div>
                    <div className="step-content">
                      <h4>Create ABHA</h4>
                      <p>Create your ABHA Number with a unique ABHA .</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-card content">
                <h3>Login</h3>
                <p className="pt-3">Verify with your mobile number</p>
                <form onSubmit={handleSubmit} className="pt-4">
                  <input
                    type="tel"
                    maxLength={10}
                    pattern="[6-9]{1}[0-9]{9}"
                    placeholder="Please Enter Mobile Number."
                    value={mobile}
                    autoComplete="off"
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      setMobile(value);
                    }}
                    className="mobile-input"
                  />

                  <p className="text-center my-2 fw-bold">OR</p>

                  <div className="qr-code-text" onClick={handleScanQrCode}>
                    Scan QR to Link & Register
                  </div>
                  {showQrModal && (
                    <div
                      className="modal d-block"
                      tabIndex="-1"
                      role="dialog"
                      style={{
                        backgroundColor: "rgba(0,0,0,0.5)",
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 1050
                      }}
                    >
                      <div
                        className="modal-dialog"
                        role="document"
                        style={{ maxWidth: "400px", width: "100%" }}
                      >
                        <div className="modal-content p-4 text-center">
                          <h5 className="mb-3">Scan this QR Code</h5>
                          <img
                            src={qrcode}
                            alt="QR Code"
                            style={{
                              width: "100%",
                              height: "auto",
                              marginBottom: "20px"
                            }}
                          />
                          <button
                            className="btn btn-secondary"
                            onClick={() => {
                              setShowQrModal(false);
                            }}
                          >
                            Close
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                  {msg && (
                    <p
                      style={{
                        color: "#cf1f1f"
                      }}
                    >
                      {msg}
                    </p>
                  )}
                  {error && (
                    <p
                      style={{
                        color: error.includes("successfully")
                          ? "green"
                          : "#cf1f1f"
                      }}
                    >
                      {error}
                    </p>
                  )}
                  <button
                    type="submit"
                    className={`continue-btn ${
                      !mobileLength || isLoading ? "bg-disable" : ""
                    }`}
                    disabled={!mobileLength || isLoading}
                  >
                    {isLoading ? "Sending OTP..." : "Continue"}
                  </button>
                </form>
                <div className="nha-logo-container">
                  <span>APPROVED BY NHA</span>
                  <img src={about} alt="NHA Logo" className="nha-logo" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default LoginMobileOTPSend;
